import { Dict, default as MixpanelSDK } from "mixpanel-browser";

const KEY = process.env.REACT_APP_MIXPANEL_KEY;
if (KEY) {
	MixpanelSDK.init(KEY, {
		debug: process.env.NODE_ENV === "development",
		track_pageview: true,
		persistence: "localStorage",
	});
}

const IS_PRODUCTION = process.env.NODE_ENV === "production" && KEY;
// const IS_PRODUCTION = KEY ? true : false;

const mixpanel = {
	identify: (id: string) => {
		if (IS_PRODUCTION) MixpanelSDK.identify(id);
	},
	reset: () => {
		if (IS_PRODUCTION) MixpanelSDK.reset();
	},
	alias: (id: string | string) => {
		if (IS_PRODUCTION) MixpanelSDK.alias(id);
	},
	track: (name: string, props: Dict) => {
		if (IS_PRODUCTION) MixpanelSDK.track(name, props);
	},
	pageview: () => {
		if (IS_PRODUCTION) MixpanelSDK.track_pageview();
	},
	people: {
		set: (props: Dict) => {
			if (IS_PRODUCTION) MixpanelSDK.people.set(props);
		},
	},
};

export default mixpanel;
